import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    background: #FFFFFF;
    font-family: Mulish;
`;

export const Header = styled.div`
    padding: 18px 20px 16px;
    border-bottom: 1px solid #EEF1F6;
    color: #2B3240;
    font-size: 0.95rem;
    font-weight: 800;
`;

export const List = styled.div`
    flex: 1;
    overflow-y: auto;
    padding: 12px 10px;

    ::-webkit-scrollbar { width: 8px; }
    ::-webkit-scrollbar-thumb { background-color: #BABABA; border-radius: 5px; }
`;

export const State = styled.div`
    padding: 24px 12px;
    text-align: center;
    color: #8A94A6;
    font-size: 0.85rem;
`;
